import {useId as $lVGRk$useId, mergeProps as $lVGRk$mergeProps, filterDOMProps as $lVGRk$filterDOMProps, useSlotId as $lVGRk$useSlotId} from "@react-aria/utils";
import {useLongPress as $lVGRk$useLongPress, usePress as $lVGRk$usePress, useHover as $lVGRk$useHover, isFocusVisible as $lVGRk$isFocusVisible} from "@react-aria/interactions";
import {useMessageFormatter as $lVGRk$useMessageFormatter} from "@react-aria/i18n";
import {useOverlayTrigger as $lVGRk$useOverlayTrigger} from "@react-aria/overlays";
import {useSelectableList as $lVGRk$useSelectableList, useSelectableItem as $lVGRk$useSelectableItem} from "@react-aria/selection";
import {getItemCount as $lVGRk$getItemCount} from "@react-stately/collections";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $235cea8b956832d5$exports = {};

$parcel$export($235cea8b956832d5$exports, "useMenuTrigger", () => $235cea8b956832d5$export$dc9c12ed27dd1b49);
var $96dc1c2244700b52$exports = {};
var $1a8690630e322ec6$exports = {};
$1a8690630e322ec6$exports = JSON.parse("{\"longPressMessage\":\"اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة\"}");


var $fc3ddb23f24e2eea$exports = {};
$fc3ddb23f24e2eea$exports = JSON.parse("{\"longPressMessage\":\"Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто\"}");


var $eb1dc9b603d71109$exports = {};
$eb1dc9b603d71109$exports = JSON.parse("{\"longPressMessage\":\"Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku\"}");


var $2d95ec734354bc1d$exports = {};
$2d95ec734354bc1d$exports = JSON.parse("{\"longPressMessage\":\"Langt tryk eller tryk på Alt + pil ned for at åbne menuen\"}");


var $e5cd075746034abd$exports = {};
$e5cd075746034abd$exports = JSON.parse("{\"longPressMessage\":\"Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen\"}");


var $74fe177ce68f16a7$exports = {};
$74fe177ce68f16a7$exports = JSON.parse("{\"longPressMessage\":\"Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού\"}");


var $a59d721fbb9df903$exports = {};
$a59d721fbb9df903$exports = JSON.parse("{\"longPressMessage\":\"Long press or press Alt + ArrowDown to open menu\"}");


var $617e1630a7dd16ea$exports = {};
$617e1630a7dd16ea$exports = JSON.parse("{\"longPressMessage\":\"Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú\"}");


var $3218d8c72495e96b$exports = {};
$3218d8c72495e96b$exports = JSON.parse("{\"longPressMessage\":\"Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool\"}");


var $f2f412c97ede0995$exports = {};
$f2f412c97ede0995$exports = JSON.parse("{\"longPressMessage\":\"Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli\"}");


var $7640150678ab200d$exports = {};
$7640150678ab200d$exports = JSON.parse("{\"longPressMessage\":\"Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu.\"}");


var $84c642b6d2ee0f06$exports = {};
$84c642b6d2ee0f06$exports = JSON.parse("{\"longPressMessage\":\"לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט\"}");


var $57727cf256b928dd$exports = {};
$57727cf256b928dd$exports = JSON.parse("{\"longPressMessage\":\"Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika\"}");


var $05114af5675ffd82$exports = {};
$05114af5675ffd82$exports = JSON.parse("{\"longPressMessage\":\"Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához\"}");


var $38a13f141610baa6$exports = {};
$38a13f141610baa6$exports = JSON.parse("{\"longPressMessage\":\"Premere a lungo o premere Alt + Freccia giù per aprire il menu\"}");


var $02ea00ed085de6ca$exports = {};
$02ea00ed085de6ca$exports = JSON.parse("{\"longPressMessage\":\"長押しまたは Alt+下矢印キーでメニューを開く\"}");


var $220ff1248b85a717$exports = {};
$220ff1248b85a717$exports = JSON.parse("{\"longPressMessage\":\"길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기\"}");


var $bf5ad8f2c050e288$exports = {};
$bf5ad8f2c050e288$exports = JSON.parse("{\"longPressMessage\":\"Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“.\"}");


var $f3bc8e284003309a$exports = {};
$f3bc8e284003309a$exports = JSON.parse("{\"longPressMessage\":\"Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa\"}");


var $7cb4a85cce2978c1$exports = {};
$7cb4a85cce2978c1$exports = JSON.parse("{\"longPressMessage\":\"Langt trykk eller trykk Alt + PilNed for å åpne menyen\"}");


var $4bbc2c2d2f167f68$exports = {};
$4bbc2c2d2f167f68$exports = JSON.parse("{\"longPressMessage\":\"Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen\"}");


var $ed008113cc0b674e$exports = {};
$ed008113cc0b674e$exports = JSON.parse("{\"longPressMessage\":\"Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu\"}");


var $62bfb2a2daab045d$exports = {};
$62bfb2a2daab045d$exports = JSON.parse("{\"longPressMessage\":\"Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu\"}");


var $856d8cc1d19b4c06$exports = {};
$856d8cc1d19b4c06$exports = JSON.parse("{\"longPressMessage\":\"Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu\"}");


var $a46dcfaf580fda03$exports = {};
$a46dcfaf580fda03$exports = JSON.parse("{\"longPressMessage\":\"Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul\"}");


var $d919ca79cce015eb$exports = {};
$d919ca79cce015eb$exports = JSON.parse("{\"longPressMessage\":\"Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню\"}");


var $dcee2f03ab5d79f4$exports = {};
$dcee2f03ab5d79f4$exports = JSON.parse("{\"longPressMessage\":\"Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol\"}");


var $ec308c4d4a31d7ef$exports = {};
$ec308c4d4a31d7ef$exports = JSON.parse("{\"longPressMessage\":\"Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol\"}");


var $639001ec689e223b$exports = {};
$639001ec689e223b$exports = JSON.parse("{\"longPressMessage\":\"Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni\"}");


var $37090bf5b661009a$exports = {};
$37090bf5b661009a$exports = JSON.parse("{\"longPressMessage\":\"Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn\"}");


var $4ca70371ce142708$exports = {};
$4ca70371ce142708$exports = JSON.parse("{\"longPressMessage\":\"Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın\"}");


var $772cc5075c4120ad$exports = {};
$772cc5075c4120ad$exports = JSON.parse("{\"longPressMessage\":\"Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню\"}");


var $a280148193f17e0f$exports = {};
$a280148193f17e0f$exports = JSON.parse("{\"longPressMessage\":\"长按或按 Alt + 向下方向键以打开菜单\"}");


var $08dca4706d9e39f3$exports = {};
$08dca4706d9e39f3$exports = JSON.parse("{\"longPressMessage\":\"長按或按 Alt+向下鍵以開啟功能表\"}");


$96dc1c2244700b52$exports = {
    "ar-AE": $1a8690630e322ec6$exports,
    "bg-BG": $fc3ddb23f24e2eea$exports,
    "cs-CZ": $eb1dc9b603d71109$exports,
    "da-DK": $2d95ec734354bc1d$exports,
    "de-DE": $e5cd075746034abd$exports,
    "el-GR": $74fe177ce68f16a7$exports,
    "en-US": $a59d721fbb9df903$exports,
    "es-ES": $617e1630a7dd16ea$exports,
    "et-EE": $3218d8c72495e96b$exports,
    "fi-FI": $f2f412c97ede0995$exports,
    "fr-FR": $7640150678ab200d$exports,
    "he-IL": $84c642b6d2ee0f06$exports,
    "hr-HR": $57727cf256b928dd$exports,
    "hu-HU": $05114af5675ffd82$exports,
    "it-IT": $38a13f141610baa6$exports,
    "ja-JP": $02ea00ed085de6ca$exports,
    "ko-KR": $220ff1248b85a717$exports,
    "lt-LT": $bf5ad8f2c050e288$exports,
    "lv-LV": $f3bc8e284003309a$exports,
    "nb-NO": $7cb4a85cce2978c1$exports,
    "nl-NL": $4bbc2c2d2f167f68$exports,
    "pl-PL": $ed008113cc0b674e$exports,
    "pt-BR": $62bfb2a2daab045d$exports,
    "pt-PT": $856d8cc1d19b4c06$exports,
    "ro-RO": $a46dcfaf580fda03$exports,
    "ru-RU": $d919ca79cce015eb$exports,
    "sk-SK": $dcee2f03ab5d79f4$exports,
    "sl-SI": $ec308c4d4a31d7ef$exports,
    "sr-SP": $639001ec689e223b$exports,
    "sv-SE": $37090bf5b661009a$exports,
    "tr-TR": $4ca70371ce142708$exports,
    "uk-UA": $772cc5075c4120ad$exports,
    "zh-CN": $a280148193f17e0f$exports,
    "zh-TW": $08dca4706d9e39f3$exports
};






function $235cea8b956832d5$export$dc9c12ed27dd1b49(props, state, ref) {
    let { type: type = 'menu' , isDisabled: isDisabled , trigger: trigger = 'press'  } = props;
    let menuTriggerId = $lVGRk$useId();
    let { triggerProps: triggerProps , overlayProps: overlayProps  } = $lVGRk$useOverlayTrigger({
        type: type
    }, state, ref);
    let onKeyDown = (e)=>{
        if (isDisabled) return;
        if (trigger === 'longPress' && !e.altKey) return;
        if (ref && ref.current) switch(e.key){
            case 'Enter':
            case ' ':
                if (trigger === 'longPress') return;
            // fallthrough
            case 'ArrowDown':
                // Stop propagation, unless it would already be handled by useKeyboard.
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('first');
                break;
            case 'ArrowUp':
                if (!('continuePropagation' in e)) e.stopPropagation();
                e.preventDefault();
                state.toggle('last');
                break;
        }
    };
    let formatMessage = $lVGRk$useMessageFormatter((/*@__PURE__*/$parcel$interopDefault($96dc1c2244700b52$exports)));
    let { longPressProps: longPressProps  } = $lVGRk$useLongPress({
        accessibilityDescription: formatMessage('longPressMessage'),
        onLongPressStart () {
            state.close();
        },
        onLongPress () {
            state.open('first');
        }
    });
    let pressProps = {
        onPressStart (e) {
            // For consistency with native, open the menu on mouse/key down, but touch up.
            if (e.pointerType !== 'touch' && e.pointerType !== 'keyboard' && !isDisabled) // If opened with a screen reader, auto focus the first item.
            // Otherwise, the menu itself will be focused.
            state.toggle(e.pointerType === 'virtual' ? 'first' : null);
        },
        onPress (e) {
            if (e.pointerType === 'touch' && !isDisabled) state.toggle();
        }
    };
    triggerProps = $lVGRk$mergeProps(triggerProps, trigger === 'press' ? pressProps : longPressProps);
    return {
        menuTriggerProps: {
            ...triggerProps,
            id: menuTriggerId,
            onKeyDown: onKeyDown
        },
        menuProps: {
            ...overlayProps,
            'aria-labelledby': menuTriggerId
        }
    };
}


var $9e81e1e13d86f3bd$exports = {};

$parcel$export($9e81e1e13d86f3bd$exports, "useMenu", () => $9e81e1e13d86f3bd$export$38eaa17faae8f579);


function $9e81e1e13d86f3bd$export$38eaa17faae8f579(props, state, ref) {
    let { shouldFocusWrap: shouldFocusWrap = true , ...otherProps } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let domProps = $lVGRk$filterDOMProps(props, {
        labelable: true
    });
    let { listProps: listProps  } = $lVGRk$useSelectableList({
        ...otherProps,
        ref: ref,
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        shouldFocusWrap: shouldFocusWrap
    });
    return {
        menuProps: $lVGRk$mergeProps(domProps, {
            role: 'menu',
            ...listProps
        })
    };
}


var $c5d816999d2ff723$exports = {};

$parcel$export($c5d816999d2ff723$exports, "useMenuItem", () => $c5d816999d2ff723$export$9d32628fc2aea7da);




function $c5d816999d2ff723$export$9d32628fc2aea7da(props, state, ref) {
    let { isSelected: isSelected , isDisabled: isDisabled , key: key , onClose: onClose , closeOnSelect: closeOnSelect , isVirtualized: isVirtualized , onAction: onAction  } = props;
    let role = 'menuitem';
    if (state.selectionManager.selectionMode === 'single') role = 'menuitemradio';
    else if (state.selectionManager.selectionMode === 'multiple') role = 'menuitemcheckbox';
    let labelId = $lVGRk$useSlotId();
    let descriptionId = $lVGRk$useSlotId();
    let keyboardId = $lVGRk$useSlotId();
    let ariaProps = {
        'aria-disabled': isDisabled,
        role: role,
        'aria-label': props['aria-label'],
        'aria-labelledby': labelId,
        'aria-describedby': [
            descriptionId,
            keyboardId
        ].filter(Boolean).join(' ') || undefined
    };
    if (state.selectionManager.selectionMode !== 'none') ariaProps['aria-checked'] = isSelected;
    if (isVirtualized) {
        ariaProps['aria-posinset'] = state.collection.getItem(key).index;
        ariaProps['aria-setsize'] = $lVGRk$getItemCount(state.collection);
    }
    let onKeyDown = (e)=>{
        // Ignore repeating events, which may have started on the menu trigger before moving
        // focus to the menu item. We want to wait for a second complete key press sequence.
        if (e.repeat) return;
        switch(e.key){
            case ' ':
                if (!isDisabled && state.selectionManager.selectionMode === 'none' && closeOnSelect !== false && onClose) onClose();
                break;
            case 'Enter':
                // The Enter key should always close on select, except if overridden.
                if (!isDisabled && closeOnSelect !== false && onClose) onClose();
                break;
        }
    };
    let onPressStart = (e)=>{
        if (e.pointerType === 'keyboard' && onAction) onAction(key);
    };
    let onPressUp = (e)=>{
        if (e.pointerType !== 'keyboard') {
            if (onAction) onAction(key);
            // Pressing a menu item should close by default in single selection mode but not multiple
            // selection mode, except if overridden by the closeOnSelect prop.
            if (onClose && (closeOnSelect !== null && closeOnSelect !== void 0 ? closeOnSelect : state.selectionManager.selectionMode !== 'multiple')) onClose();
        }
    };
    let { itemProps: itemProps  } = $lVGRk$useSelectableItem({
        selectionManager: state.selectionManager,
        key: key,
        ref: ref,
        shouldSelectOnPressUp: true
    });
    let { pressProps: pressProps  } = $lVGRk$usePress({
        onPressStart: onPressStart,
        onPressUp: onPressUp,
        isDisabled: isDisabled
    });
    let { hoverProps: hoverProps  } = $lVGRk$useHover({
        isDisabled: isDisabled,
        onHoverStart () {
            if (!$lVGRk$isFocusVisible()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(key);
            }
        }
    });
    return {
        menuItemProps: {
            ...ariaProps,
            ...$lVGRk$mergeProps(itemProps, pressProps, hoverProps, {
                onKeyDown: onKeyDown
            })
        },
        labelProps: {
            id: labelId
        },
        descriptionProps: {
            id: descriptionId
        },
        keyboardShortcutProps: {
            id: keyboardId
        }
    };
}


var $2e6444d9033828ce$exports = {};

$parcel$export($2e6444d9033828ce$exports, "useMenuSection", () => $2e6444d9033828ce$export$73f7a44322579622);

function $2e6444d9033828ce$export$73f7a44322579622(props) {
    let { heading: heading , 'aria-label': ariaLabel  } = props;
    let headingId = $lVGRk$useId();
    return {
        itemProps: {
            role: 'presentation'
        },
        headingProps: heading ? {
            // Techincally, menus cannot contain headings according to ARIA.
            // We hide the heading from assistive technology, and only use it
            // as a label for the nested group.
            id: headingId,
            'aria-hidden': true
        } : {
        },
        groupProps: {
            role: 'group',
            'aria-label': ariaLabel,
            'aria-labelledby': heading ? headingId : undefined
        }
    };
}




export {$235cea8b956832d5$export$dc9c12ed27dd1b49 as useMenuTrigger, $9e81e1e13d86f3bd$export$38eaa17faae8f579 as useMenu, $c5d816999d2ff723$export$9d32628fc2aea7da as useMenuItem, $2e6444d9033828ce$export$73f7a44322579622 as useMenuSection};
//# sourceMappingURL=module.js.map
